import { useTranslation } from "react-i18next";

import { SUPPORTED_LANGUAGES } from "../i18n";

/**
 * Three-button pill switcher (uk · ru · en). Persisting the choice is
 * handled by i18next-browser-languagedetector via the
 * `seogeeks:lang` localStorage key.
 */
export default function LanguageSwitcher({ className = "" }) {
  const { i18n } = useTranslation();
  const current = i18n.resolvedLanguage || i18n.language || "uk";

  return (
    <div
      className={`inline-flex rounded-full bg-white ring-1 ring-slate-200 p-0.5 ${className}`}
    >
      {SUPPORTED_LANGUAGES.map((l) => (
        <button
          key={l.code}
          type="button"
          onClick={() => i18n.changeLanguage(l.code)}
          aria-pressed={current === l.code}
          className={[
            "px-2.5 py-1 text-xs rounded-full transition",
            current === l.code
              ? "bg-brand-600 text-white"
              : "text-slate-600 hover:text-slate-900",
          ].join(" ")}
        >
          {l.code.toUpperCase()}
        </button>
      ))}
    </div>
  );
}
